import axiosInstance from '../../core/axiosConfig';

export type CourierProvider = 'WOLT' | 'RESTAURANT';
export type DeliveryPricing = 'WOLT' | 'OWN_COURIER';

/**
 * Wybor kuriera przy akceptacji. restaurantDeliveryIncome - ile z dostawy zostanie restauracji
 * przy danym wyborze (ujemne = doplata restauracji do Wolta).
 */
export interface CourierOptions {
  deliveryPricing: DeliveryPricing;
  customerDeliveryFee: number;
  currency: string;
  /** null - lokal bez wlasnych kurierow. available = false - trasa dluzsza niz ostatni prog. */
  ownCourier: {
    available: boolean;
    cost: number | null;
    distanceKm: number;
    maxDistanceKm: number;
    restaurantDeliveryIncome: number | null;
  } | null;
  wolt: {
    available: boolean;
    cost: number | null;
    estimatedMinutes: number | null;
    restaurantDeliveryIncome: number | null;
  };
}

export class OrderService {
  cancelOrder = async (orderId: number) => {
    await axiosInstance.patch(`/order/cancel?orderId=${orderId}`);
  };

  confirmOrder = async (
    orderId: number,
    estimatedTime: string,
    courierProvider?: CourierProvider,
  ) => {
    const courier = courierProvider ? `&courierProvider=${courierProvider}` : '';
    await axiosInstance.patch(
      `/order/confirm?orderId=${orderId}&estimatedTime=${estimatedTime}${courier}`,
    );
  };

  getCourierOptions = async (orderId: number): Promise<CourierOptions> => {
    const response = await axiosInstance.get(`/order/${orderId}/courier-options`);
    return response.data;
  };

  markOrderAsReady = async (orderId: number) => {
    await axiosInstance.patch(`/order/ready-for-pickup?orderId=${orderId}`);
  };

  markOrderAsPickedUp = async (orderId: number) => {
    await axiosInstance.patch(`/order/picked-up?orderId=${orderId}`);
  };

  markOwnCourierOnTheWay = async (orderId: number) => {
    await axiosInstance.patch(`/order/own-courier/on-the-way?orderId=${orderId}`);
  };

  markOwnCourierDelivered = async (orderId: number) => {
    await axiosInstance.patch(`/order/own-courier/delivered?orderId=${orderId}`);
  };
}
